import { render, staticRenderFns } from "./GenerateReport.vue?vue&type=template&id=b532171c&"
import script from "./GenerateReport.vue?vue&type=script&lang=js&"
export * from "./GenerateReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports